<div id="pdfcontainer">
<div class="poll-block poll-main">

    <div *ngIf="poll; else defaultPoll">
        <div class="poll-title" >
            {{poll.name}}
        </div>
        <div class="poll-description">
            {{poll.description}}
        </div>
    </div>
    <ng-template #defaultPoll>
        <div class="poll-title" >
            Новая форма
        </div>
        <div class="poll-description">
            Описание
        </div>
    </ng-template>
</div>
<ng-container *ngIf="poll_statistics; else loading">
        <div class="poll-block" *ngFor="let poll_stat of poll_statistics">
            <ng-container *ngIf="poll_stat.wd_id" [ngSwitch]="poll_stat.wd_id">
                <div *ngSwitchCase="'string'">
                    <word-cloud-stats [data]="poll_stat"></word-cloud-stats>
                </div>
                <div *ngSwitchCase="'textarea'">
                    textarea
                </div>
                <div *ngSwitchCase="'radio'">
                    <bar-vert-stats [data]="poll_stat"></bar-vert-stats>
                </div>  
                <div *ngSwitchCase="'checkbox'">
                    <pie-stats [data]="poll_stat"></pie-stats>
                </div>
            </ng-container>
        </div>
</ng-container>
<ng-template #loading>
    <div>Loading...</div>
</ng-template>
</div>

<div *ngIf="poll_statistics.length>0; else none">
    <button class="export" (click)="exportAsPDF('pdfcontainer', poll.name)">
        Export as PDF
    </button>
</div>
<ng-template #none>
    <div>
        Ещё никто не прошёл этот опрос :с
    </div>
</ng-template>